export enum TipoCobro {
  REMESA = 0,
  TRANSFERENCIA = 4,
  BIZUM = 2,
  COMPENSACION = 5,
  PASARELA = 7,
}
